import React, { useState, useEffect, Fragment } from 'react';
import axios from 'axios';

import mixpanel from 'mixpanel-browser';

// Actions
import { getUnreadChats } from '../../actions/chatActions';
import { getUnreadCount } from '../../actions/notificationActions';

// Components - imported
import { Avatar } from '@material-ui/core';
import DefaultAvatar from 'react-avatar';
import ProfileDropdown from '../Dropdowns/ProfileDropdown';
import AuthDropdown from '../Dropdowns/AuthDropdown';
import Avatar_For_Headers from '../common/Avatar_For_Headers';

// Icons - material UI
import NightsStayOutlinedIcon from '@material-ui/icons/NightsStayOutlined';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import MenuIcon from '@material-ui/icons/Menu';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import PinDropOutlinedIcon from '@material-ui/icons/PinDropOutlined';
import RotateLeftOutlinedIcon from '@material-ui/icons/RotateLeftOutlined';
import LocalMallOutlinedIcon from '@material-ui/icons/LocalMallOutlined';
import AccountBalanceOutlinedIcon from '@material-ui/icons/AccountBalanceOutlined';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import ModeCommentOutlinedIcon from '@material-ui/icons/ModeCommentOutlined';
import HistoryOutlinedIcon from '@material-ui/icons/HistoryOutlined';
import Spinner from '../common/Spinner';

const Nav_Settings = ({ 
    sideNav, 
    handleSlideMenu, 
    auth, 
    chat,
    page, 
    notification,
    getUnreadChats,
    getUnreadCount,
    goBack
}) => {

    // Analytics 
    const [sentMixpanel, setSentMixpanel] = useState(false);

    // Screen Width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Toggle Dropdwon
    const [profileDropdown, setProfileDropdown] = useState(false);
    const [authDropdown, setAuthDropdown] = useState(false);

    // Alert Badge
    const [badgeValue_Notifications, setBadgeValue_Notifications] = useState(0);
    const [badgeValue_Chats, setBadgeValue_Chats] = useState(0);

    const hostname = window.location.hostname;

    useEffect(() => {

        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());
        
        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, [window.location]);
    
    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    useEffect(() => {

        // Update the header animation based on the sideNav state
        if(sideNav) {
            document.getElementById('feed-header').classList.remove("active");
            return "feed__header";
        } else {
            setTimeout(() => {
                document.getElementById('feed-header').classList.add("active");
            }, 700)
        }
    }, [sideNav])

    useEffect(() => {

        // Fetch unread counts for notifications and chats
        if(auth.user){
            getUnreadCount(auth.user._id);
            getUnreadChats(auth.user._id);

            if(authDropdown) setAuthDropdown(false);
        } else {
            if(profileDropdown) setProfileDropdown(false);
        }

    }, [notification.notifications, auth.user, page]);

    useEffect(() => {

        // Update the badge value for unread Chats
        setBadgeValue_Chats(chat.num_unread_chats);

    }, [chat.num_unread_chats]);

    useEffect(() => {

        // Update the badge value for unread notifications
        setBadgeValue_Notifications(notification.num_unread);

    }, [notification.num_unread]);

    // Extract the current path from the window location
    let previousURL = window.location.pathname;
    // Split the path into an array based on '/'
    var pathArray = previousURL.split( '/' );

    console.log('HELLO PATH ARRAY');
    console.log(pathArray);
    console.log('FORTH PATH');

    // Check if the third path element exists
    if(pathArray[2]) {
        console.log(pathArray[2]);
    }

    // Determine mobile and tablet screen sizes
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;
    const notFullScreen = windowWidth <= 1170;

     // Initialize Mixpanel and track settings Nav page view
    const handleMixpanel = () => {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_ID);
        mixpanel.track("Settings Nav Page View");
    }

    // Check if the code is running in production and Mixpanel event hasn't been sent yet
    if(process.env.NODE_ENV === 'production' && !sentMixpanel && !hostname.includes('xbuysell')) {
        
        // Initialize Mixpanel and track the event
        handleMixpanel();

        // Set the flag to indicate that Mixpanel event has been sent
        setSentMixpanel(true);
    }

    let user_name;

    if(!auth.loading && auth.isAuthenticated) {
        user_name = `${auth.user.first_name} ${auth.user.last_name && auth.user.last_name}`
    }

    // --- ImageKit (img optimization service) ---
    
    let optimized_profile_img_path;

    if(auth.user && auth.user.img) {
   
        // Replace the firebase URL with ImageKit.io URL-endpoint
        optimized_profile_img_path = auth.user.img.replace("https://firebasestorage.googleapis.com","https://ik.imagekit.io/pba3w2st28/");
    }

    // --- END: ImageKit (img optimization service) ---

    return (
        <div className="feed">

            {/* Nav Header */}
            <div className="feed__header" id="feed-header">
                
                {/* Icon & Text */}
                <h2 style={{display:'flex'}}>

                    <div style={{display:'flex', alignItems: 'center'}}>
                        {isMobile && (
                            <Fragment>
                                <div onClick={goBack} style={{marginRight: '10px'}} className="shopFeed__backBtn noMargin noPadding">
                                    <div>
                                        <ArrowBackIcon />
                                    </div>
                                </div>

                                {/* Alerts Badge: displayed if it's a mobile device and badgeValue is greater than 0 */}
                                {/* {isMobile && badgeValue_Chats > 0 ? (
                                    <span className="feed-header-badge defaultBadge">
                                        {badgeValue_Chats}
                                    </span>
                                ) : null} */}
                            </Fragment>
                        )}

                        More
                    </div>

                    <div style={{right:'20px', position:'absolute', display: 'flex'}}>

                        {/* --- Avatar Icon --- */}
                        {/* <Avatar_For_Headers /> */}
                        {/* --- END: Avatar Icon --- */}

                    </div>
                        
                </h2>

            </div>
            
            {auth.loading ? <Spinner /> : (
                <Fragment>
                    {/* Account Edit  */}
                    {auth.user ? (
                        <Fragment>
                            <div style={{background: '#f5f8fa', color: 'grey', fontSize: '13px', fontWeight: 'bold', padding: '5px 10px'}}>
                                <span>Account Info</span>
                            </div>
                            <a style={{textDecoration:'none'}} href={auth.user ? `/user/${auth.user._id}` : '/profile'}>
                                <div className={`settings__item pictogram`}>
                                    <div className='sidebar__profile topNav'>
                                        <div className="post__avatar">

                                            {auth.user && auth.user.img ? (
                                                <Avatar src={optimized_profile_img_path} />
                                            ) : (
                                                <DefaultAvatar name={auth.user && `${auth.user.first_name} ${auth.user.last_name}`} />
                                            )}
                                        </div>
                                        <div  className='sidebar__profile__text__container'>
                                            <div className='sidebar__profile__text'>
                                                <div>
                                                    <span>
                                                        {user_name}
                                                    </span>
                                                </div>
                                                <div>
                                                    <div>
                                                        <span>View Profile</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <ChevronRightIcon />
                                </div>
                            </a>
                            <a style={{textDecoration:'none'}} href="/notifications">
                                <div className={`settings__item pictogram`}>
                                    <span style={{display: 'flex'}}>
                                        <span style={{marginRight: '5px'}}>
                                            <NotificationsNoneIcon />
                                        </span>
                                        Notifications
                                        {badgeValue_Notifications > 0 && (
                                            <span className="feed-header-badge settings_item_badge">
                                                {badgeValue_Notifications}
                                            </span>
                                        )}
                                    </span>
                                    <ChevronRightIcon />
                                </div>
                            </a>
                            <a style={{textDecoration:'none'}} href="/settings/activity">
                                <div className={`settings__item pictogram ${pathArray[2] && pathArray[2].toLowerCase().includes("activity") ? 'active' : null}`}>
                                    <span style={{display: 'flex'}}>
                                        <span style={{marginRight: '5px'}}>
                                            <HistoryOutlinedIcon />
                                        </span>
                                        My Activity
                                    </span>
                                    <ChevronRightIcon />
                                </div>
                            </a>
                            <a style={{textDecoration:'none'}} href="/settings/account">
                                <div className={`settings__item pictogram ${pathArray[2] && pathArray[2].toLowerCase().includes("account") ? 'active' : null}`}>
                                    <span style={{display: 'flex'}}>
                                        <span style={{marginRight: '5px'}}>
                                            <SettingsOutlinedIcon />
                                        </span>
                                        Account Settings
                                    </span>
                                    <ChevronRightIcon />
                                </div>
                            </a>
                        </Fragment>
                    ) : (
                        <Fragment>
                            <a style={{textDecoration:'none'}} href="/user_registration">
                                <div className={`settings__item ${pathArray[2] && pathArray[2].toLowerCase().includes("help") ? 'active' : null}`}>
                                    <p>Log In / Sign Up</p>
                                    <ChevronRightIcon />
                                </div>
                            </a>
                        </Fragment>
                    )}

                    <div style={{background: '#f5f8fa', color: 'grey', fontSize: '13px', fontWeight: 'bold', padding: '5px 10px'}}>
                        <span>Help & Feedback</span>
                    </div>

                    {/* Help */}
                    <a style={{textDecoration:'none'}} href="/settings/help">
                        <div className={`settings__item ${pathArray[2] && pathArray[2].toLowerCase().includes("help") ? 'active' : null}`}>
                            <p>Customer Support</p>
                            <ChevronRightIcon />
                        </div>
                    </a>

                    {/* Help */}
                    <a style={{textDecoration:'none'}} href="/settings/feedback">
                        <div className={`settings__item ${pathArray[2] && pathArray[2].toLowerCase().includes("feedback") ? 'active' : null}`}>
                            <p>Give Us Feedback</p>
                            <ChevronRightIcon />
                        </div>
                    </a>

                    {auth.user && (
                        <Fragment>
                            <div style={{background: '#f5f8fa', color: 'grey', fontSize: '13px', fontWeight: 'bold', padding: '5px 10px'}}>
                                <span>For Professionals</span>
                            </div>

                            {/* About */}
                            <a style={{textDecoration:'none'}} href="/ads">
                                <div className={`settings__item`}>
                                    <p>Manage Ads</p>
                                    <ChevronRightIcon />
                                </div>
                            </a>

                            <a style={{textDecoration:'none'}} href="/settings/payments">
                                <div className={`settings__item ${pathArray[2] && pathArray[2].toLowerCase().includes("payments") ? 'active' : null}`}>
                                    <p>Payments</p>
                                    <ChevronRightIcon />
                                </div>
                            </a>
                        </Fragment>
                    )}

                    <div style={{background: '#f5f8fa', color: 'grey', fontSize: '13px', fontWeight: 'bold', padding: '5px 10px'}}>
                        <span>General Info</span>
                    </div>

                    {/* About */}
                    <a style={{textDecoration:'none'}} href="/settings/about">
                        <div className={`settings__item ${pathArray[2] && pathArray[2].toLowerCase().includes("about") ? 'active' : null}`}>
                            <p>About</p>
                            <ChevronRightIcon />
                        </div>
                    </a>

                    {/* How It Works */}
                    <a style={{textDecoration:'none'}} href="/settings/howitworks">
                        <div className={`settings__item ${pathArray[2] && pathArray[2].toLowerCase().includes("howitworks") ? 'active' : null}`}>
                            <p>How It Works</p>
                            <ChevronRightIcon />
                        </div>
                    </a>

                    {/* Return Policy */}
                    <a style={{textDecoration:'none'}} href="/settings/returns">
                        <div className={`settings__item ${pathArray[2] && pathArray[2].toLowerCase().includes("returns") ? 'active' : null}`}>
                            <p>Return Policy</p>
                            <ChevronRightIcon />
                        </div>
                    </a>

                    {/* Trust and Safety */}
                    <a style={{textDecoration:'none'}} href="/settings/trust_and_safety">
                        <div className={`settings__item ${pathArray[2] && pathArray[2].toLowerCase().includes("trust_and_safety") ? 'active' : null}`}>
                            <p>Trust and Safety</p>
                            <ChevronRightIcon />
                        </div>
                    </a>

                    {/* Terms of Service */}
                    <a style={{textDecoration:'none'}} href="/settings/terms">
                        <div className={`settings__item ${pathArray[2] && pathArray[2].toLowerCase().includes("terms") ? 'active' : null}`}>
                            <p>Terms of Service</p>
                            <ChevronRightIcon />
                        </div>
                    </a>

                    {/* Privacy Policy */}
                    <a style={{textDecoration:'none'}} href="/settings/privacy">
                        <div className={`settings__item ${pathArray[2] && pathArray[2].toLowerCase().includes("privacy") ? 'active' : null}`}>
                            <p>Privacy Policy</p>
                            <ChevronRightIcon />
                        </div>
                    </a>

                    {/* Log Out */}
                    {auth.user && (
                        <a style={{textDecoration:'none'}} href="/logout">
                            <div className="settings__item logout">
                                <p>Log Out</p>
                            </div>
                        </a>
                    )}

                    {/* Add space to the bottom of the page, due to the bottom nav */}
                    <div style={{height: '100px'}}></div>
                </Fragment>
            )}
        </div>
    )
}

export default Nav_Settings;
